if (!customElements.get("variant-swatch-filter")) {
  customElements.define(
    "variant-swatch-filter",
    class VariantSwatchFilter extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector("[data-swatch-filter-trigger]");
        this.bottomSheet = this.querySelector("bottom-sheet-modal");
        this.panel = this.querySelector("[data-swatch-filter-panel]");
        this.searchInput = this.querySelector("[data-swatch-filter-search]");
        this.variantOption = this.closest(".wt-product__option");
        this.options = Array.from(
          this.querySelectorAll("[data-swatch-filter-option]"),
        );
        this.isOpen = false;
      }

      connectedCallback() {
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleVariantChangeEnd = this.handleVariantChangeEnd.bind(this);
        this.handleSheetOpen = () => {
          this.isOpen = true;
          this.syncOptions();
        };
        this.handleSheetClose = () => {
          this.isOpen = false;
          this.resetFilter();
        };
        this.bottomSheet?.addEventListener("bottom-sheet-modal:open", this.handleSheetOpen);
        this.bottomSheet?.addEventListener("bottom-sheet-modal:close", this.handleSheetClose);
        this.searchInput?.addEventListener("input", this.handleSearch);
        this.options.forEach((option) =>
          option.addEventListener("click", this.handleOptionClick),
        );
        this.addEventListener("keydown", this.handleKeyDown);
        this.variantOption?.addEventListener("change", this.handleChange);
        window.addEventListener("variantChangeEnd", this.handleVariantChangeEnd);
        this.syncOptions();
      }

      disconnectedCallback() {
        this.searchInput?.removeEventListener("input", this.handleSearch);
        this.options.forEach((option) =>
          option.removeEventListener("click", this.handleOptionClick),
        );
        this.removeEventListener("keydown", this.handleKeyDown);
        this.variantOption?.removeEventListener("change", this.handleChange);
        window.removeEventListener("variantChangeEnd", this.handleVariantChangeEnd);
        this.bottomSheet?.removeEventListener("bottom-sheet-modal:open", this.handleSheetOpen);
        this.bottomSheet?.removeEventListener("bottom-sheet-modal:close", this.handleSheetClose);
      }

      open() {
        if (this.isOpen) return;

        this.bottomSheet?.open();
      }

      close({ restoreFocus = false } = {}) {
        if (!this.isOpen) return;

        this.bottomSheet?.close({ restoreFocus });
      }

      handleSearch() {
        const query = this.searchInput.value.trim().toLocaleLowerCase();
        this.options.forEach((option) => {
          const value = option.dataset.filterValue.toLocaleLowerCase();
          option.closest("li").hidden = !value.includes(query);
        });
      }

      handleOptionClick(event) {
        const option = event.currentTarget;
        if (option.dataset.combinationProductUrl) return;
        const input = document.getElementById(option.dataset.inputId);
        if (!input || input.classList.contains("disabled")) return;

        input.click();
        this.syncOptions();
        this.close({ restoreFocus: true });
      }

      handleChange(event) {
        if (event.target.matches('input[type="radio"]')) this.syncOptions();
      }

      handleVariantChangeEnd() {
        this.syncOptions();
      }

      handleKeyDown(event) {
        if (
          event.target === this.trigger &&
          (event.key === "ArrowDown" || event.key === "ArrowUp")
        ) {
          event.preventDefault();
          this.open();
          return;
        }

        if (
          event.target === this.searchInput &&
          (event.key === "ArrowDown" || event.key === "ArrowUp")
        ) {
          const options = this.getVisibleOptions();
          if (!options.length) return;
          event.preventDefault();
          const target = event.key === "ArrowUp" ? options.at(-1) : options[0];
          target.focus();
          return;
        }

        const option = event.target.closest("[data-swatch-filter-option]");
        if (!option || !this.isOpen) return;

        const options = this.getVisibleOptions();
        if (!options.length) return;
        const currentIndex = options.indexOf(option);
        let nextIndex = currentIndex;

        if (event.key === "ArrowDown") nextIndex = (currentIndex + 1) % options.length;
        if (event.key === "ArrowUp") nextIndex = (currentIndex - 1 + options.length) % options.length;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = options.length - 1;

        if (nextIndex !== currentIndex) {
          event.preventDefault();
          options[nextIndex]?.focus();
        }
      }

      getVisibleOptions() {
        return this.options.filter(
          (option) => !option.disabled && !option.closest("li").hidden,
        );
      }

      syncOptions() {
        this.options.forEach((option) => {
          const input = document.getElementById(option.dataset.inputId);
          if (!input) return;

          option.disabled = input.classList.contains("disabled");
          option.setAttribute("aria-selected", input.checked ? "true" : "false");
          if (!input.checked) return;

          const swatch = option.querySelector("[data-swatch-filter-color]");
          const triggerSwatch = this.trigger.querySelector(
            "[data-swatch-filter-color]",
          );
          const triggerLabel = this.trigger.querySelector(
            "[data-swatch-filter-label]",
          );
          if (triggerSwatch && swatch) {
            triggerSwatch.style.cssText = swatch.style.cssText;
            triggerSwatch.dataset.productSwatch = swatch.dataset.productSwatch;
            triggerSwatch.hidden = false;
          }
          if (triggerLabel) triggerLabel.textContent = input.value;
          const triggerBadge = this.trigger.querySelector(
            "[data-swatch-filter-badge]",
          );
          if (triggerBadge) {
            const badge = option.querySelector(".color-label");
            triggerBadge.innerHTML = badge ? badge.outerHTML : "";
          }
        });
      }

      resetFilter() {
        if (this.searchInput) this.searchInput.value = "";
        this.options.forEach((option) => {
          option.closest("li").hidden = false;
        });
      }
    },
  );
}
